import { render, staticRenderFns } from "./HeldTransactions.vue?vue&type=template&id=2dd162a8&"
import script from "./HeldTransactions.vue?vue&type=script&lang=js&"
export * from "./HeldTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports